import request from "./request.service";

const generalValidation = (groupId, phoneNum) => {
  if (!groupId || !phoneNum || `${phoneNum}`?.length != 8) {
    throw new Error(
      "Гишүүн нэмэх талбарууд алдаатай байна. Утасны дугаар болон Family Id г шалгана уу!"
    );
  }
};
const createTFamily = async (adminPhone, memberPhone, note) => {
  try {
    if (`${adminPhone}`?.length != 8 || `${memberPhone}`?.length != 8) {
      throw new Error("Утасны дугаарын орон дутуу байна!");
    }
    const res = await request(
      `/unitel/tfamily/api/v1/external/crm/groups`,
      "POST",
      {
        adminPhone: `${adminPhone}`,
        memberPhone: `${memberPhone}`,
        note: note,
      }
    );
    if (res.data.code == 599) {
      throw new Error(res.data.message);
    }
    //check status code
  } catch (err) {
    throw err;
  }
};

const deleteTFamily = async (groupId) => {
  try {
    if (`${groupId}`) throw new Error("Group id not found");
    const res = await request(
      `/unitel/tfamily/api/v1/external/crm/groups/${groupId}`,
      "DELETE"
    );
    if (res.data.code == 599) {
      throw new Error(res.data.message);
    }
  } catch (err) {
    throw err;
  }
};

const addMember = async (groupId, phoneNum, note) => {
  try {
    generalValidation(groupId, phoneNum);
    const res = await request(
      `/unitel/tfamily/api/v1/external/crm/groups/${groupId}/members`,
      "POST",
      {
        phone: phoneNum,
      }
    );
    if (res.data.code == 599) {
      throw new Error(res.data.message);
    }
  } catch (err) {
    throw err;
  }
};

const removeMember = async (groupId, phoneNum, note) => {
  try {
    generalValidation(groupId, phoneNum);
    const res = await request(
      `/unitel/tfamily/api/v1/external/crm/groups/${groupId}/members/${phoneNum}`,
      "DELETE"
    );
    if (res.data.code == 599) {
      throw new Error(res.data.message);
    }
  } catch (err) {
    throw err;
  }
};

const adminChange = async (groupId, phoneNum, note) => {
  try {
    generalValidation(groupId, phoneNum);
    const res = await request(
      `/unitel/tfamily/api/v1/external/crm/groups/${groupId}/transfer-admin`,
      "POST",
      {
        newAdminPhone: `${phoneNum}`,
      }
    );
    if (res.data.code == 599) {
      throw new Error(res.data.message);
    }
  } catch (err) {
    throw err;
  }
};

const familyLog = async (
  groupId,
  startDate = new Date("2026-04-15").toISOString().slice(0, 10),
  offset = 0,
  limit = 10
) => {
  try {
    if (!`${groupId}`) throw new Error("Group id оруулна уу!");
    const res = await request(
      `/unitel/tfamily/api/v1/external/crm/groups/${groupId}/audit-log?since=${startDate}&page=${Math.floor(
        offset / 10
      )}&size=${limit}`
    );
    if (res.data.code == 599) {
      throw new Error(res.data.message);
    }
    return res.data;
  } catch (err) {
    throw err;
  }
};

const getGroupByPhone = async (phoneNum) => {
  try {
    if (`${phoneNum}`) throw new Error("Phone Number not found");
    const res = await request(
      `/unitel/tfamily/api/v1/external/groups/by-phone/${phoneNum}`
    );
  } catch (err) {
    throw err;
  }
};
const getGroupById = async (groupId) => {
  try {
    if (`${groupId}`) throw new Error("Group id not found");
    const res = await request(
      `/unitel/tfamily/api/v1/external/groups/${groupId}`
    );
  } catch (err) {
    throw err;
  }
};
const getMigrationLog = async (mobile) => {
  try {
    if (!`${mobile}`) throw new Error("Дугаар оруулна оруулна уу!");
    const res = await request(`/unitel/mfamily/${mobile}`);

    if (res.data.code == 599) {
      throw new Error(res.data.message);
    }
    return res.data;
  } catch (err) {
    throw err;
  }
};
export default {
  createTFamily,
  deleteTFamily,
  addMember,
  removeMember,
  adminChange,
  familyLog,
  getGroupByPhone,
  getGroupById,
  getMigrationLog,
};
